import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_priceNotification = _resolveComponent("priceNotification")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_storeLocationDetail = _resolveComponent("storeLocationDetail")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_hereMap = _resolveComponent("hereMap")!
  const _component_orderTypeToggle = _resolveComponent("orderTypeToggle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_locationSearch = _resolveComponent("locationSearch")!
  const _component_storeLocationList = _resolveComponent("storeLocationList")!
  const _component_locationDelivery = _resolveComponent("locationDelivery")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_gridContainer = _resolveComponent("gridContainer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        role: "tablist",
        "aria-label": "order type toggle"
      }, {
        default: _withCtx(() => [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_priceNotification, {
                key: 0,
                isDelivery: _ctx.isDelivery,
                showNotification: _ctx.priceNotification
              }, null, 8, ["isDelivery", "showNotification"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_gridContainer, {
        noPadding: "",
        forceOverscroll: false
      }, {
        default: _withCtx(() => [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_modal, {
                  isOpen: _ctx.locationSlug,
                  onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectLogic())),
                  canDismiss: "",
                  class: "location-modal"
                }, {
                  default: _withCtx(() => [
                    (_ctx.locationSlug)
                      ? (_openBlock(), _createBlock(_component_storeLocationDetail, {
                          key: 0,
                          slug: _ctx.locationSlug,
                          onClose: _ctx.close,
                          onChangeDelivery: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDelivery = true)),
                          showMap: ""
                        }, null, 8, ["slug", "onClose"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["isOpen"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 1,
                class: _normalizeClass(["ion-justify-content-between ion-padding mobile-row", { 'mobile-deliver-row': _ctx.isDelivery }]),
                id: "pickupAndDeliveryContent"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "map-col",
                    style: {"margin-bottom":"30px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_hereMap, {
                        class: "radius map",
                        "data-cy": "mobile-map",
                        isDelivery: _ctx.isDelivery
                      }, null, 8, ["isDelivery"]),
                      (_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_orderTypeToggle, {
                            key: 0,
                            showToolbar: !_ctx.isDetailPage,
                            modelValue: _ctx.isDelivery,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDelivery) = $event)),
                            "data-cy": "order-toggle",
                            style: {"margin-top":"-30px"}
                          }, null, 8, ["showToolbar", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: _normalizeClass({ 'ion-hide': _ctx.isDelivery })
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isDetailPage && _ctx.isMobile && !_ctx.isDelivery)
                        ? (_openBlock(), _createBlock(_component_locationSearch, {
                            key: 0,
                            class: "map-search",
                            "data-cy": "mobile-search"
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.locationSlug)
                        ? (_openBlock(), _createBlock(_component_storeLocationList, {
                            key: 1,
                            style: {"margin-bottom":"200px"}
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: _normalizeClass({ 'ion-hide': !_ctx.isDelivery || _ctx.isDetailPage })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_locationDelivery, {
                        onChangePickup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDelivery = false)),
                        style: {"margin-bottom":"50px"}
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"]))
            : (_openBlock(), _createBlock(_component_ion_card, {
                key: 2,
                class: _normalizeClass(["mobile-hide-card location-card", { 'toggle-offset': !_ctx.isDetailPage }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, {
                    class: _normalizeClass(["ion-justify-content-between ion-align-items-start ion-padding pa-0 full-height", { 'price-offset': _ctx.priceNotification, 'detail-page': _ctx.isDetailPage }])
                  }, {
                    default: _withCtx(() => [
                      (_ctx.priceNotification)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            size: "12",
                            class: "pa-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_priceNotification, {
                                isDelivery: _ctx.isDelivery,
                                showNotification: _ctx.priceNotification
                              }, null, 8, ["isDelivery", "showNotification"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, {
                        size: "12",
                        "size-md": "5",
                        class: _normalizeClass(["radius pa-0 action-col", { 'ion-hide': _ctx.isDelivery }]),
                        style: {"overscroll-behavior":"none"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_orderTypeToggle, {
                            showToolbar: !_ctx.isDetailPage,
                            modelValue: _ctx.isDelivery,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isDelivery) = $event)),
                            "data-cy": "order-toggle"
                          }, null, 8, ["showToolbar", "modelValue"]),
                          (!_ctx.locationSlug)
                            ? (_openBlock(), _createBlock(_component_storeLocationList, {
                                key: 0,
                                searchBar: "",
                                class: _normalizeClass([{ 'ion-hide': _ctx.isDelivery }, "desktop-list"])
                              }, null, 8, ["class"]))
                            : (_openBlock(), _createBlock(_component_storeLocationDetail, {
                                key: 1,
                                slug: _ctx.locationSlug,
                                onClose: _ctx.close,
                                onChangeDelivery: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDelivery = true))
                              }, null, 8, ["slug", "onClose"]))
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      (_ctx.isDelivery && !_ctx.isDetailPage)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 1,
                            size: "12",
                            "size-md": "5",
                            class: "radius pa-0 action-col",
                            style: {"overscroll-behavior":"none"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_locationDelivery, {
                                onChangePickup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDelivery = false))
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, {
                        size: "12",
                        "size-md": "7",
                        class: "map-col hide-overflow full-height"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_hereMap, {
                            class: "radius map",
                            isDelivery: _ctx.isDelivery
                          }, null, 8, ["isDelivery"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}